import { InjectionToken } from '@angular/core';
import { IDatiqAction } from '@dat/datiq-core/models';

export const datiqCellActionToken: InjectionToken<IDatiqCellActionService> =
    new InjectionToken<IDatiqCellActionService>('cell action token');

export interface IDatiqCellActionService {
    fireAction(action: IDatiqAction): void;
}
